/* eslint-disable react-hooks/exhaustive-deps */
import { Flex, TonicProps } from '@tonic-one/react';
import React, { Key, ReactNode, useEffect } from 'react';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import { CasTreeTransferProvider, useCasTreeTransferContext } from './context';
import LeftBox from './LeftBox';
import RightBox from './RightBox';
// import TransferButton from './TransferButton';

interface CasTreeTransferProps extends Omit<TonicProps, 'ref'> {
  children: React.ReactNode;
  defaultValue: Key[];
  handleChange?: (value: Key[]) => void;
  isLeftOnly?: boolean;
  disabled?: boolean;
}

const CasTreeTransferContainer: React.FC<{ children: ReactNode } & TonicProps> =
  React.memo((props) => {
    const { children, ...tonicProps } = props;
    return (
      <Flex
        direction="row"
        justifyContent="space-between"
        width="100%"
        {...tonicProps}
      >
        {children}
      </Flex>
    );
  });

const CasTreeTransferLeftContainer: React.FC<
  { children: ReactNode } & TonicProps
> = React.memo((props) => {
  const { children, ...tonicProps } = props;
  return (
    <Flex
      direction="row"
      justifyContent="center"
      alignItems="center"
      width="520px"
      height="368px"
      {...tonicProps}
    >
      {children}
    </Flex>
  );
});

// do not change default values in handleChange, either it will cause infinite loop
const CasTreeTransfer = React.memo(
  ({
    children,
    defaultValue,
    handleChange,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isLeftOnly = false,
    disabled = false,
    ...tonicProps
  }: CasTreeTransferProps) => {
    const {
      finallyValue,
      handleDefaultValueChange,
      handleCheckListLeftChange,
      handleIsBrightRightChange,
      handleDisabledChange,
    } = useCasTreeTransferContext();
    useEffect(() => {
      // if (defaultValue.length) {
      //   handleDefaultValueChange(defaultValue);
      //   handleCheckListLeftChange(defaultValue);
      //   handleIsBrightRightChange(true);
      // }
      handleDefaultValueChange(defaultValue);
      handleCheckListLeftChange(defaultValue);
      handleIsBrightRightChange(!!defaultValue.length);
    }, [defaultValue]);
    useEffect(() => {
      // isLeftOnly === true 时，可能就没有handleChange
      if (handleChange) {
        handleChange(finallyValue);
      }
    }, [finallyValue]);
    useEffect(() => {
      handleDisabledChange(disabled);
    }, [disabled]);
    useWhyDidYouUpdate('CasTreeTransfer', {
      children,
      defaultValue,
      handleChange,
      isLeftOnly,
      disabled,
    });
    return (
      <>
        {isLeftOnly ? (
          <CasTreeTransferLeftContainer {...tonicProps}>
            {children}
          </CasTreeTransferLeftContainer>
        ) : (
          <CasTreeTransferContainer {...tonicProps}>
            {children}
          </CasTreeTransferContainer>
        )}
      </>
    );
  }
);

const CasTreeTransferWithStore = (props: CasTreeTransferProps) => (
  <CasTreeTransferProvider>
    <CasTreeTransfer {...props} />
  </CasTreeTransferProvider>
);
// CasTreeTransferWithStore.TransferLeftBox = LeftBox;
// CasTreeTransferWithStore.TransferRightBox = RightBox;
// CasTreeTransferWithStore.TransferButton = TransferButton;
export default React.memo(CasTreeTransferWithStore);
export const TransferLeftBox = LeftBox;
export const TransferRightBox = RightBox;
export * from './TransferButton';
